export default "__VITE_ASSET__BeB$nlUt__$_?component__"